import type {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  ReactNode,
} from "react";
import { Button } from "../button";

import styles from "./card-button.module.css";

export type CardButtonProps = {
  children: ReactNode;
  type?: "button" | "submit" | "reset";
  tag?: "a" | "button";
} & ButtonHTMLAttributes<HTMLButtonElement> &
  AnchorHTMLAttributes<HTMLAnchorElement>;

export function CardButton({
  children,
  type = "button",
  tag = "button",
  ...props
}: CardButtonProps) {
  return (
    <Button
      tag={tag}
      variant="situational"
      className={styles.Button}
      type={type}
      {...props}
    >
      {children}
    </Button>
  );
}
